// components/Common/CommonToaster.js
import React, { useEffect } from "react";
import { CheckCircle, XCircle, AlertTriangle, Info, X } from "lucide-react";
import "./CommonToaster.scss";

const typeConfig = {
  success: {
    icon: CheckCircle,
    label: "Success",
  },
  error: {
    icon: XCircle,
    label: "Error",
  },
  warning: {
    icon: AlertTriangle,
    label: "Warning",
  },
  info: {
    icon: Info,
    label: "Info",
  },
};

const CommonToaster = ({ show, message, type = "success", onClose, position = "top-end", delay = 5000 }) => {
  const config = typeConfig[type] || typeConfig.success;
  const Icon = config.icon;

  useEffect(() => {
    if (!show || !delay) return;
    const timer = setTimeout(() => onClose?.(), delay);
    return () => clearTimeout(timer);
  }, [show, delay, onClose]);

  if (!show) return null;

  // Map position prop to CSS modifier
  const posClass = position === "top-center" ? "ct--top-center"
    : position === "bottom-end" ? "ct--bottom-end"
    : "ct--top-end";

  return (
    <div className={`ct-container ${posClass}`}>
      <div className={`ct ct--${type}`} role="alert">
        <div className="ct__icon">
          <Icon size={18} />
        </div>
        <div className="ct__body">
          <span className="ct__message">{message}</span>
        </div>
        <button className="ct__close" onClick={onClose} aria-label="Close">
          <X size={16} />
        </button>
        <div className="ct__progress" style={{ animationDuration: `${delay}ms` }} />
      </div>
    </div>
  );
};

export default CommonToaster;
